import {
    memo,
    ReactElement,
    ButtonHTMLAttributes
} from "react";
import LoadingSpinner from "./loading_spinner";
import { useNavigate } from "react-router-dom";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
    title: any;
    myStyle?: string;
    onClick?: any;
    icon?: any;
    props?: any;
    loading?: boolean;
    link?:string;
    imageTag?:any
}

export function Button({ onClick, title, myStyle, icon, loading , link , imageTag}: Props, props: any): ReactElement {
    const navigation = useNavigate();

    const handleClick = () => {
        if (!loading) {
            if (link) {
                navigation(link);
            } else if (onClick) {
                onClick();
            }
        }
    };

    return (
        <button
            className={`button ${myStyle}`}
            onClick={handleClick}
            {...props}
        >
            {loading ?
                <LoadingSpinner/>
                :
                <h3 className="button-text">
                    {icon &&
                        <img src={icon} className="ms-1" alt="هامرز" />
                    }

            {imageTag && 
            imageTag
            }
                    {title}
                </h3>
            }
        </button>
    )
}

export default memo(Button);